import PaymentList from './List'
import PaymentEdit from './Edit'
import PaymentCreate from './Create'

export default {
  list: PaymentList,
  edit: PaymentEdit,
  create: PaymentCreate
}
